import convertToArray from "../utils/convertToArray";

function fetchProjects() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            fetch("https://us-central1-portfolio-336c8.cloudfunctions.net/getProjects").then(res => res.json()).then(data => {
                dispatch({
                    type: "AddProject",
                    projects: convertToArray(data.data)
                });
                resolve(true);
            });
        });
    };
}

export {
    fetchProjects
};


// WEBPACK FOOTER //
// ./src/Actions/projects.js